import { Header } from './components/Header'
import { SocialRail } from './components/SocialRail'
import { Hero } from './components/Hero'
import { ValuesStrip } from './components/ValuesStrip'
import { Mission } from './components/Mission'
import { About } from './components/About'
import { Events } from './components/Events'
import { Calendar } from './components/Calendar'
import { Help } from './components/Help'
import { Donate } from './components/Donate'
import { Volunteer } from './components/Volunteer'
import { Social } from './components/Social'
import { Contact } from './components/Contact'
import { Footer } from './components/Footer'
import { useScrollProgress, useScrolled, useScrollSpy } from './hooks/useScroll'
import { useEvents } from './hooks/useEvents'

// Module-level constant so its identity is stable across renders (the scroll-spy
// effect depends on it).
const SECTION_IDS = ['nosotros', 'eventos', 'calendario', 'ayuda', 'redes', 'contacto']

export default function App() {
  const progress = useScrollProgress()
  const scrolled = useScrolled(40)
  const active = useScrollSpy(SECTION_IDS)
  const { events } = useEvents()

  return (
    <div data-cdd-root>
      <Header progress={progress} scrolled={scrolled} active={active} />
      <SocialRail />
      <main>
        <Hero />
        <ValuesStrip />
        <Mission />
        <About />
        <Events />
        <Calendar events={events} />
        <Help />
        <Donate />
        <Volunteer />
        <Social />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
